import clock from './flip-clock';
import { isExpiredDateTime } from './services/utility';

function OfferAlertDiv(identifier) {
    this.id = identifier;
    this.ele = document.getElementById(identifier);
    this.textEle = document.querySelector((`#${identifier} .text`));
}

OfferAlertDiv.prototype.clear = function () {
    this.ele.classList.add('d-none');
    this.ele.classList.remove('d-block');
    this.textEle.innerText = '';
};
OfferAlertDiv.prototype.message = function (message) {
    this.ele.classList.add('d-block');
    this.ele.classList.remove('d-none');
    this.textEle.innerText = message;
};

function offers() {
    const offerCode = 'WELCOME2021';
    const showModal = true;
    const expiryDateTime = new Date('1/15/2021 23:59'); //Format: Month/Day/Year Hours:Minutes
    const landingPageTopBanner = ''; //'/assets/images/offers/halloween/landing-page-top-banner.svg';
    const headerLogo = ''; //'/assets/images/offers/halloween/header-logo.svg';

    function bindOfferCopyEvent() {
        const offerAlert = new OfferAlertDiv('offer-alert');
        const offerCopy = document.getElementById('offer1-copy');
        if (!offerCopy) {
            return;
        }
        offerCopy.addEventListener('click', () => {
            const code = offerCode;
            navigator.clipboard.writeText(code).then(function () {
                offerAlert.clear();
                offerAlert.message('Copied to clipboard.');
            }, function (err) {
                console.error('Could not copy text: ', err);
            });
        });
    }

    function bindOffer2CopyEvent() {
         const offer2Alert = new OfferAlertDiv('offer2-alert');
        const offer2Copy = document.getElementById('offer2-copy');
        if (!offer2Copy) {
            return;
        }
        offer2Copy.addEventListener('click', () => {
            const code = offerCode;
            navigator.clipboard.writeText(code).then(function () {
                offer2Alert.clear();
                offer2Alert.message('Copied to clipboard.');
            }, function (err) {
                console.error('Could not copy text: ', err);
            });
        });
    }

    function bindOfferTryItEvents() {
        const offerTryItClassItems = document.getElementsByClassName('offer-try-it');
        if (!offerTryItClassItems) {
            return;
        }
        for (let i = 0; i < offerTryItClassItems.length; i++) {
            offerTryItClassItems[i].addEventListener('click', function (evt) {
                const code = this.getAttribute("data-code") || offerCode; // BFSC19
                const plan = this.getAttribute("data-plan"); // 'PRO', 'CHAMP', 'BUSINESS_CHAMP', 'CHAMP_AGENCY'
                const billing = this.getAttribute("data-billing"); // 'MONTHLY', 'YEARLY'
                // const pricingSwitch = document.getElementById('pricing-switch');
                // const billing = (pricingSwitch && pricingSwitch.checked ? 'MONTHLY' : 'YEARLY') || 'YEARLY';
                let url = '/signup';
                if (code) {
                    url += ('?offerCode=' + code);
                    if (billing) {
                        url += ('-' + billing);
                    }
                    if (plan) {
                        url += ('-' + plan);
                    }
                }
                window.location.href = url;
            }, false);
        }
    }

    function bindOfferModal() {
        if (isExpiredDateTime(expiryDateTime)) {
            $('#cta-content').show();
            $('#cta-section').addClass('mt-0');
            $('#hero-section').remove();
            $('#bridge-section-banner').remove();
            $('#offer-section-banner').remove();
            $('#offer-section-yearly').remove();
            return;
        }

        $('#cta-content').hide();

        if(!showModal) {
            return;
        }

        if ($('#popup-modal')) {
            clock(expiryDateTime);
            $('#popup-modal').modal('show');
        }

        $('#popup-get-offer').on('click', (e) => {
            e.preventDefault();
            $('#popup-modal').modal('hide');
            window.location.href = '#yearly-offer-card'
        });
    }

    function applyOtherChanges() {
        const homeLocation = window.location.pathname;
        if (isExpiredDateTime(expiryDateTime) || homeLocation !== '/') {
            return;
        }

        if(landingPageTopBanner) {
            $('#home-top-banner').attr('src', landingPageTopBanner);
            $('#home-top-banner-hero').css('background-image','url('+landingPageTopBanner+')');
        }

        if(headerLogo) {
            $('#header-logo').attr('src', headerLogo);
        }
    }

    setTimeout(function () {
        applyOtherChanges();
        bindOfferCopyEvent();
        bindOffer2CopyEvent();
        bindOfferTryItEvents();
        bindOfferModal();
    }, 1000);
}

export default offers;




